// extracted by mini-css-extract-plugin
export default {"card":"wY-z"};